import { Injectable } from '@angular/core';
import { RateScheduleServiceBase } from 'scaletech-core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class RateScheduleDataService extends RateScheduleServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
